import { render, staticRenderFns } from "./ProductSpplierListing.vue?vue&type=template&id=d9d77c08"
import script from "./ProductSpplierListing.vue?vue&type=script&lang=js"
export * from "./ProductSpplierListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports